/**
 * Client program-assignment writes through the global apiClient. Non-throwing.
 */

import { api, type ApiResponse } from '@/lib/apiClient';
import type { PostAssignmentBody } from '@schemas/programs';

export function assignProgram(body: PostAssignmentBody): Promise<ApiResponse & { assignmentId?: string }> {
  return api.post('/api/clients/program-assignments', body);
}

/** "Archive" in the UI = pause the assignment server-side. */
export function pauseAssignment(assignmentId: string): Promise<ApiResponse> {
  return api.patch(`/api/clients/program-assignments?id=${encodeURIComponent(assignmentId)}`, { status: 'paused' });
}
